export const INSERT_ARTICLE = 'INSERT_ARTICLE'
